import { routes } from './router'
import { store } from './store'
import { SSOService } from './sso-service'
import { beforeAppRouteInit } from '@/services/appInit.service'

export default {
  install(Vue, options) {
    if (!options.client_id) {
      throw new TypeError('Missing required option client_id')
    }

    if (!options.namespace) {
      throw new TypeError('Missing required option namespace')
    }

    if (!options.domain) {
      throw new TypeError('Missing required option domain')
    }

    if (!options.callbackUrl) {
      throw new TypeError('Missing required option callbackUrl')
    }

    if (!options.scope) {
      throw new TypeError('Missing required option scope')
    }

    if (!options.router) {
      throw new TypeError('Missing required option router')
    }

    if (!options.store) {
      throw new TypeError('Missing required option store')
    }

    options.router.addRoutes(routes)
    options.store.registerModule(['sso'], store)

    const sso = new SSOService({
      client_id: options.client_id,
      namespace: options.namespace,
      domain: options.domain,
      callbackUrl: options.callbackUrl,
      scope: options.scope
    })

    Vue.prototype.$sso = sso

    options.router.beforeEach(async (to, from, next) => {
      const token = localStorage.getItem('dsp/bearer_token')

      if (!token && to.name !== 'login' && to.name !== 'sso-callback') {
        return next('/login')
      }

      if (token && to.name === 'login') {
        return next('/skane/event')
      }

      if (token && to.name === 'sso-callback') {
        return next('/skane/event')
      }

      await beforeAppRouteInit(to, from, next)

      next()
    })

    if (sso.bearerToken) {
      options.store.set('sso/user', sso.decodeUser())
    }
  }
}
